import { DialogTitle, styled } from "@mui/material";

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
}));